import { createLazyReactDirective } from '../../shell/ng';

export default createLazyReactDirective(
  async () => (await import('./SettingsApiPage')).SettingsApiPage,
  'settingsApiPage',
);
